module.exports = __webpack_public_path__ + "static/media/pvcBlanco7.e1e8a7a0.jpg";